export default {
    // Organization Customer
    GET_USER_ROLE: '/me',
    LOGIN_USER: '/skip-sso-login',
    LANGUAGE_CHANGE: '/frontend-portal-language',
    GET_NOTICE_LISTING: '/notice-translation-dcr',
    GET_STATE_LIST: '/getstate',
    GET_CITY_LIST: '/getcities',
    GET_ALLOCATED_SALES_OFFICE_LIST: '/getallocatedsalesoffice',
    GET_ORG_CLASSIFICATION_LIST: '/getclassifications?name=Org',
    GET_ULTMARC_FACILITY_SUPER_TYPE_LIST: '/getultmarcfacilitylevelone',
    GET_ULTMARC_FACILITY_TYPE_LIST: '/getultmarcfacilityleveltwo',
    GET_MEDICAL_SPECIALITY_SUPER_TYPE_LIST: '/getspecialitylevelone?name="Org"',
    GET_MEDICAL_SPECIALITY_TYPE_LIST: '/getspecialityleveltwo',
    GET_BU_LIST: '/getbu',
    GET_DIVISION_LIST: '/getdivision',
    GET_BRANCH_LIST: '/getbranch',
    GET_SALES_OFFICE_LIST: '/getsalesoffice',
    GET_DELETE_REASON_LIST: '/getultmarcplandeleteoptions',
    GET_ALLOCATED_MR_LIST: '/getallocatedmrs',
    GET_ORGANIZATION_INQUIRY_LIST: '/orgcustomer',
    GET_ORGANIZATION_INFO: '/getcutomerinfo',
    GET_CHILD_FACILITIES: '/getcutomerinfochildfacility',
    GET_PARENT_FACILITIES: '/getcutomerinfoparentfacility',
    GET_AFFILIATED_PERSON_DETAILS: '/getcutomerinfoaffiliatedperson',
    GET_ALLOCATED_EMPLOYEES_DETAILS: '/getcutomerinfoallocatedemp',
    GET_ORGANIZATION_CHANGE_REQUEST_DATA: '/getorgcustomerchangerequestdata',
    UPDATE_ORGANIZATION_CUSTOMER_DETAILS: '/DcrRequest/OrganizationCustomer/update',
    DELETE_ORGANIZATION_CUSTOMER: '/DcrRequest/OrganizationCustomer/delete',
    
    // Person Customer
    GET_PERSON_CLASSIFICATION_LIST: '/getclassifications?name=Person',
    GET_PERSON_MEDICAL_SPECIALITY_SUPER_TYPE_LIST: '/getspecialitylevelone?name=Person',
    GET_UNIVERSITY_LIST: '/getuni',
    GET_PERSON_MEDICAL_SPECIALITY_TYPE_LIST: '/getspecialityleveltwo',
    GET_PERSON_INQUIRY_LIST: '/percustomer',
    GET_PERSON_INFO: '/getpercustinfo',
    GET_PERSON_CHANGE_REQUEST_DATA: '/getpercustomerchangerequestdata',
    UPDATE_PERSON_CUSTOMER_DETAILS: '/DcrRequest/PersonCustomer/update',
    GET_GENDER_LIST: '/getgender',
    UPDATE_AFFILIATION_DETAILS: '/DcrRequest/PersonCustomer/updateAffiliation',
    DELETE_AFFILIATION: '/DcrRequest/PersonCustomer/deleteAffiliation',
    ADD_AFFILIATION: '/DcrRequest/PersonCustomer/addAffiliation',

    // New Customer Request
    GET_MANAGEMENTBODY_TYPE_LIST: '/getmanagementbodytype',
    GET_SUBURB_LIST: '/getsuburb',
    GET_STREET_LIST: '/getstreet',
    GET_MEDICAL_SPECIALITY_LIST: '/getmedicalspeciality',
    GET_AFFILIATED_DEPARTMEMT: '/getaffiliateddepartment',
    GET_ROLE_LIST: '/getjobtitle',
    ADD_ORGANIZATION_CUSTOMER: '/DcrRequest/OrganizationCustomer/add',
    ADD_PERSON_CUSTOMER: '/DcrRequest/PersonCustomer/add',
    GET_CUSTOMER_CODE: '/get-customer-type-code',

    // Customer Request Status Inquiry
    GET_SUBMISSION_DATA_LIST: '/get-submission-data',
    GET_SUBMISSION_TYPE_LIST: '/get-submission-type',
    GET_ORG_CUSTOMER_TYPE_LIST: '/getcustomertype?submission_data=organization_customer',
    GET_PERSON_CUSTOMER_TYPE_LIST: '/getcustomertype?submission_data=person_customer',
    GET_CUSTOMER_TYPE: '/getcustomertype',
    CUSTOMER_REQUEST_STATUS_INQUIRY: '/search-customers',
    GET_CUSTOMER_REQUEST_DETAILS: '/get-customer-detail',
    RESUBMIT_REQUEST: '/save-customer-resubmit',
    EDIT_REQUEST: '/save-customer-edit',
    WITHDRAW_ORG_REQUEST: '/withdraw-organization-customer-request',
    WITHDRAW_PERSON_REQUEST: '/withdraw-person-customer-request',
    WITHDRAW_AFFILIATION_REQUEST: '/withdraw-person-customer-affiliation-request',

    // Parent Child Facility Maintenance
    MARKET_AUTH_LIST: '/getAllocatedMarketAuthByMrId',
    PARENT_CHILD_FACILITY_LIST: '/search-facility',
    GET_PARENT_FACILITY_LIST: '/search-parent-facility',
    GET_CONFIGURABLE_PARENT_FACILITY_LIST: '/search-configurable-parent-facility',
    SAVE_PARENT_CHILD_FACILITY_CHANGE: '/save-parent-child-facility',

    // Parent Child Facility Change
    GET_PARENT_CHILD_FACILITY: '/get-parent-child-facility',
    APPROVE_REJECT: '/approve-parent-child-facility',

    // Territory Definition Maintenace
    GET_TERRITORY_BU_LIST: '/territory/bu',
    GET_TERRITORY_DIVISION_LIST: '/territory/division',
    GET_MAINTAINANCE: '/getDefaultMaintenanceWindow',
    GET_TERRITORY_BRANCH_LIST: '/territory/branch',
    GET_TERRITORY_SALES_OFFICE_LIST: '/territory/salesoffice',
    GET_TERRITORY_LIST: '/territory/territorySet',
    GET_TERRITORY_ALLOCATION_LIST: '/territory_allocation/territoryDefinitions',
    GET_EMPLOYEE_LIST: '/territory_allocation/employee',
    GET_BLOCKS_LIST: '/territoryDefinitionBlocks/tree',
    GET_BLOCKS_LIST: '/territoryDefinitionBlocks/tree',
    RESTORE_TERRITORY: '/restore_territory_definition',
    SAVE_TERRITORY_ALLOCATION: '/territory_allocation',
    GET_BLOCKS_BY_TERRITORY: '/blocks',
    GET_FACILITIES_LIST: '/block/organizationCustomers',
    SAVE_TERRITORY_DEFINITION_LIST: '/territoryDefinitionBlocks',

    //Sales Reports
    GET_EMPLOYEE_NAME: '/reports/common/employee-name',
    GET_EMAIL_EMPLOYEE_NAME: "/reports/email-maintenance/employee-name",
    GET_EMPLOYEE_LISTING: '/reports/common/search-employee',
    GET_ORGANIZATION_LIST: '/reports/common/org-list',
    GET_TARGET_PERIOD: '/reports/common/target-period',
    GET_FIXED_MONTH: '/reports/common/fixed-month-dates',
    GET_PRODUCT_TYPE_LIST: '/reports/common/product-type',
    GET_HEMP_LAW_LIST: '/reports/common/hemp-law-target-classification',
    GET_PRODUCT_LIST: '/reports/common/product',
    GET_MARKET_AUTHORIZATION_LIST: '/reports/common/market-authorization/product',
    GET_FORM_LIST: '/reports/common/form/product',
    GET_FORMULATION_LIST: '/reports/common/formulation/product',
    GET_PACKAGING_LIST: '/reports/common/pack/formulation',
    GET_HUNDRED_BEDS_LIST: '/reports/common/100-bed',
    GET_TWO_HUNDRED_BEDS_LIST: '/reports/common/200-bed',
    GET_EVALUATION_TARGET_CLASSIFICATION_LIST: '/reports/common/evaluation-target-classification',
    GET_SALES_PREFECTURE_LIST: '/reports/common/prefecture',
    GET_SALES_COUNTY_LIST: '/reports/common/county',
    GET_WHOLESALER_GROUP_LIST: '/reports/common/wholesaler-group',
    GET_LEGAL_ENTITY_LIST: '/reports/common/wholesaler-legal-entity',
    GET_DAILY_SELLOUT_REPORT: '/reports/daily-sellout/list',
    GET_MONTHLY_SELLOUT_REPORT: '/reports/monthly-sellout/list',
    GET_SELLOUT_ROTATION_REPORT: '/reports/sellout-rotation/list',
    GET_WHOLESALER_LEVEL_LIST: '/reports/common/wholesaler-organization',
    GET_MAINTENANCE_TIME: '/reports/common/ods-maintenance',

    // Email Settings
    GET_TIME_RANGE_LIST: '/reports/email-maintenance/time-range',
    GET_ORG_LEVEL_LIST: '/reports/email-maintenance/organization-info',
    ADD_EMAIL_SETTINGS: '/reports/email-maintenance',
    LIST_EMAIL_SETTINGS: '/reports/email-maintenance/list',
    DELETE_EMAIL_SETTINGS: '/reports/email-maintenance/delete',

    //Download Reports
    GET_REPORTS_LIST: '/reports/common/user-reports-list',
    GET_FILE: '/reports/common/download-user-report'
}